// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { buttonTransparent } from "@rpsc/XDL/PreStyle/button";
import { xBaseTheme } from "@rpsc/XDL/types";
import { color, hideElementOnPrint } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            scrim: css`
                ${hideElementOnPrint}
            `,
            drawerBody: css`
                box-shadow: none;
                border: 1px solid ${color("common.border")};
                scrollbar-gutter: stable;
                background: ${color("common.white")};
            `,
            drawerContent: css`
                background: ${color("common.white")};
            `,
            drawerTitle: css`
                min-height: unset;
                background: ${color("common.white")};
            `,
            titleButton: css`
                ${buttonTransparent}
                padding: 0;
                ${IconWrapper}, svg {
                    width: 16px;
                    height: 16px;
                }
            `,
        },
        transitions: {
            bottom: {
                enabled: false,
            },
        },
    },
} as xBaseTheme["drawer"];
